import { DataTableSort } from 'studio-components';
import { createAction, props } from '@ngrx/store';
import { ApiKey } from './../api-key.model';

enum AdminApiKeyActionTypes {
  AdminApiKeyPageLoadedAction = '[Admin Api Key Page] Page Loaded',
  AdminApiKeyPageRequestedAction = '[Admin Api Key Page] Page Requested',
  AdminApiKeySortChangedAction = '[Admin Api Key Effect] Api Key Sort Changed',
  AdminApiKeysLoadedAction = '[Admin Api Key Effect] Api Keys Loaded',
  AdminApiKeyRevokeRequestedAction = '[Admin Api Key Page] Revoke Api Key ',
  AdminApiKeyRevokeRequestedSuccessAction = '[Admin Api Key Page] Revoke Api Key Success',
}

export const AdminApiKeyPageLoadedAction = createAction(
  AdminApiKeyActionTypes.AdminApiKeyPageLoadedAction,
);

export const AdminApiKeySortChangedAction = createAction(
  AdminApiKeyActionTypes.AdminApiKeySortChangedAction,
  props<{ sort: DataTableSort }>(),
);

export const AdminApiKeyPageRequestedAction = createAction(
  AdminApiKeyActionTypes.AdminApiKeyPageRequestedAction,
);

export const AdminApiKeysLoadedAction = createAction(
  AdminApiKeyActionTypes.AdminApiKeysLoadedAction,
  props<{ apiKeys: ApiKey[] }>(),
);

export const AdminApiKeyRevokeRequestedAction = createAction(
  AdminApiKeyActionTypes.AdminApiKeyRevokeRequestedAction,
  props<{ apiKeyId: number }>(),
);
export const AdminApiKeyRevokeRequestedSuccessAction = createAction(
  AdminApiKeyActionTypes.AdminApiKeyRevokeRequestedSuccessAction,
);
